<template>
  <div
    class="global-error text-center alert alert-danger clickable"
    @click="close"
  >
    {{ $t(globalError) }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalError',
  data() {
    return {
      event: null,
    };
  },
  computed: {
    ...mapGetters(['globalError']),
  },
  methods: {
    close() {
      clearTimeout(this.event);
      this.$store.commit('setGlobalError', null);
    },
  },
  created() {
    this.event = setTimeout(() => {
      this.$store.commit('setGlobalError', null);
    }, 5000);
  },
};
</script>

<style scoped>
.global-error {
  z-index: 1002;
  position: fixed;
  top: 105px;
  left: 5px;
  right: 5px;
}

@media (min-width: 767px) {
  .global-error {
    left: 50px;
    right: 50px;
  }
}
</style>
